import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { UTILS } from "utils";
import AppContainer from "components/ui/AppContainer";

import { validateInputs } from "./validate";
import GroupModifierForm from "./components/GroupModifierForm";
import AttachModifierWithGroup from "./components/AttachModifierWithGroup";
import useGroupModifierApi from "./useGroupModifierApi";
import AppModal from "components/ui/AppModal";

const initialValues = {
  values: {
    isSingleSelection: false,
    maximumAllowedSelection: 0,
    minimumAllowedSelection: 0,
    baseLanguage: {
      name: "",
    },
  },
  errors: {
    minimumAllowedSelection: "",
    maximumAllowedSelection: "",
    baseLanguage: {
      name: "",
    },
    isSingleSelection: "",
  },
};

const UpdateModiferGroup = ({
  as = "create",
  onSuccess = () => {},
  onClose = () => {},
  open = false,
  title = "Update Modifier Group",
  subTitle = "Group Modifiers under the same section",
  selectedCustomization = null,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [modifierGroup, setModifierGroup] = useState(initialValues);
  const [modifiers, setModifiers] = useState([]);
  const [toBeAttachedModifiersOptions, setToBeAttachedModifiersOptions] =
    useState([]);
  const [toBeUnLinkModifiersOptions, setToBeUnLinkModifiersOptions] = useState(
    []
  );
  // const [deleteModal, setDeleteModal] = useState({
  //   isOpen: false,
  //   item: null,
  // });

  const setError = (obj) => {
    setModifierGroup((prevState) => ({
      ...prevState,
      errors: obj,
    }));
  };

  const { loading, updateModifierGroup, getAttachedModifiers } =
    useGroupModifierApi({
      as,
      onSuccess,
      onClose,
      open,
      toBeAttachedModifiersOptions,
      toBeUnLinkModifiersOptions,
    });

  const handleValues = (key, val) => {
    setModifierGroup((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
        [key]: "",
      },
    }));
  };

  const handleText = (key, val) => {
    setModifierGroup((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        baseLanguage: {
          [key]: val,
        },
        translations: {
          en: {
            name: val,
          },
          ar: {
            name: val,
          },
        },
      },
      errors: {
        ...prevState.errors,
        baseLanguage: {
          [key]: "",
        },
      },
    }));
  };

  const handleSelection = (key, val) => {
    modifierGroup.values.maximumAllowedSelection = 1;

    setModifierGroup((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val === "single" ? true : false,
      },
      errors: {
        ...prevState.errors,
        [key]: "",
      },
    }));
  };

  const updatePrice = (key, val) => {
    const value = UTILS.NumberConversion(val);
    let Num = Number(value);
    handleValues(key, Num);
  };

  // const onClickDeleteButton = (row) => {
  //   if (row) {
  //     setDeleteModal({ isOpen: true, item: row });
  //   }
  // };

  // const handleCancel = () => setDeleteModal({ isOpen: false, item: null });

  useEffect(() => {
    if (history?.location?.state?.modifier?._id || selectedCustomization?._id) {
      getAttachedModifiers(setModifiers, setModifierGroup, selectedCustomization?._id);
    }
  }, [history?.location?.state?.modifier?._id, selectedCustomization?._id]);

  const Tag = as === "modal" ? AppModal : AppContainer;

  return (
    <Tag
      title={title}
      subTitle={subTitle}
      loading={loading}
      {...(as === "modal" && { onClose: onClose, open: open })}
    >
      {/* <Modal
        open={deleteModal.isOpen}
        modalWidth="rounded-md border border-gray-300 top-0"
        onClose={handleCancel}
      >
        <DeleteComponent
          loading={loading}
          onCancel={handleCancel}
          onDelete={unlinkModFromGroup}
          title={deleteModal.item?.baseLanguage?.name}
          Heading={t("will be permanently unlinked")}
        />
      </Modal> */}

      <GroupModifierForm
        modifierGroup={modifierGroup}
        handleText={handleText}
        handleSelection={handleSelection}
        updatePrice={updatePrice}
        onSave={() => {
          const { isValid } = validateInputs(modifierGroup, setError, t);
          updateModifierGroup({
            isValid,

            modifierGroupValues: modifierGroup.values,
          });
        }}
        as={as}
        showBackButton={as === "modal" ? false : true}
        content={
          <AttachModifierWithGroup
            toBeUnLinkModifiers={toBeUnLinkModifiersOptions}
            setToBeUnLinkModifiers={setToBeUnLinkModifiersOptions}
            toBeAttachedModifiers={toBeAttachedModifiersOptions}
            setToBeAttachedModifiers={setToBeAttachedModifiersOptions}
            modifierGroupId={history?.location?.state?.modifier?._id}
            mode="edit"
          />
        }
      />
    </Tag>
  );
};

export default UpdateModiferGroup;
